'use client';

import { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { Item } from '@/api';
import XIcon from 'public/assets/icons/x.svg';
import Share from './Share';
import THDialogWrapper from '../general/THDialogWrapper';

const ShareModal = ({ show, onHide, product, isLoading }: { show: boolean; onHide: () => void, product?: Item, isLoading?: boolean }) => {
    if (isLoading || !product) {
        return null;
    }
    return (
        <Transition.Root show={show} as={Fragment}>
            <THDialogWrapper
                as="div"
                className="relative z-[200]"
                onClose={() => {
                    onHide();
                }}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 backdrop-blur-sm bg-black/20 transition-opacity " />
                </Transition.Child>

                <div className="fixed inset-0 z-10 overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel className="relative flex flex-row justify-between items-center transform overflow-hidden rounded-[24px] bg-white p-[64px] text-left shadow-xl transition-all w-full max-w-[900px] h-auto">
                                <button className="cursor-pointer" onClick={() => onHide()}><XIcon className="absolute right-[20px] top-[20px]" /></button>
                                <Share isLoading={isLoading || false} product={product} />
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </THDialogWrapper>
        </Transition.Root>
    );
};

export default ShareModal;
